import { currentUserQuery } from "@common/api/users"
import type { QueryClient } from "@tanstack/react-query"
import { redirect } from "@tanstack/react-router"

export async function requireSystemUser(
  queryClient: QueryClient,
  to: "/" | "/settings/system",
): Promise<void> {
  const user = await queryClient.ensureQueryData(currentUserQuery())
  if (!user.is_system_user) {
    throw redirect({ to })
  }
}
